import { doesUnitHaveOpenTime } from '@utilities/doesUnitHaveOpenTime';
import useGetSelectedUnitInfo from '@components/RequestForm/utilities/hooks/useCheckBlockTimeOverlap/useGetSelectedUnitInfo/useGetSelectedUnitInfo';

export const useDoesUnitSupportOpenTime = () => {
	const unit = useGetSelectedUnitInfo();
	return !!unit?.id && doesUnitHaveOpenTime(unit);
};
